import _ from 'lodash';
import type { LogEntry, LogMap, RunResult } from '../typeDefs';

/**
 * Prepares a builder log for the redux store
 */
export const convertLog = ({ log, artifacts, checker }: RunResult): LogMap => {
    const makeList = (item: unknown): unknown[] => (Array.isArray(item) ? item : [item]);
    const result: LogMap = {};

    const filterLogs = _.pickBy(log, (_v, k) => k.startsWith('filter'));

    const handle = (
        ns: string = 'structure',
        logMap: Record<string, unknown> = {},
        artifactMap: Record<string, unknown> = {},
    ) => {
        for (let path in logMap) {
            if (ns !== 'filter' && path.startsWith('filter')) {
                continue;
            }

            let finalPath = !path ? ns : path[0] === '_' ? ns + path : ns + '.' + path;
            if (ns === 'filter') {
                finalPath = path;
            }

            if (result[finalPath]) throw new Error(`Collision: ${finalPath}`);
            const entry: LogEntry = {
                path,
                result: logMap[path],
                artifacts: artifactMap[path] ? makeList(artifactMap[path]) : null,
            };
            result[finalPath] = entry;
        }
    };

    handle('structure', log, artifacts);
    if (checker) handle('checker', checker.log, checker.artifacts);
    if (filterLogs) handle('filter', filterLogs, artifacts);

    return result;
};
